<div class="flex bg-white h-full">

  <div *ngIf="isLoading else loadedTemp" class="grid place-items-center w-full h-full ">
    <div class="w-full grid place-items-center">
      <mat-spinner [strokeWidth]="2" [diameter]="48"></mat-spinner>
      <div class="font-semibold mt-4">{{'labels.loading-data' | translate}}</div>
    </div>
  </div>

  <ng-template #loadedTemp>
    <div *ngIf="!isVehicleSelected" class="grid place-items-center w-full h-full ">
      <div class="w-full grid place-items-center">
        <div class="w-full grid place-items-center">
          <div class="tk-i-select-vehicle h-32" style="width: 1000px"></div>
        </div>
          <div class="font-semibold mt-2">{{'handover.select-vehicle' | translate}}</div>
        </div>
    </div>

    <div *ngIf="isVehicleSelected && !hasAnyHandovers" class="grid place-items-center w-full h-full ">
      <div class="w-full grid place-items-center">
        <div class="tk-i-no-handovers-for-vehicle w-32 h-48"></div>
        <div class="font-semibold ">{{'handover.no-protocols-for-vehicle' | translate}}</div>
      </div>
    </div>

    <handovermod-vehicle-handovers-list *ngIf="hasAnyHandovers && !isLoading" [handovers]="handovers"
                                        [selectedVehicle]="selectedVehicle">
    </handovermod-vehicle-handovers-list>

    <div *ngIf="isSelectProtocolInfoVisible" class="grid place-items-center w-full h-full ">
      <div class="w-full grid place-items-center">
        <div class="tk-i-select-handover w-32 h-48"></div>
        <div class="font-semibold">{{'handover.select-protocol' | translate}}</div>
      </div>
    </div>

    <div class="w-full" [ngClass]="{'hidden': !isHandoverVisible}">
      <handoverm-handover></handoverm-handover>
    </div>

  </ng-template>

</div>

